export default __webpack_public_path__ + "static/media/Flag_of_Benin.bf771f47.svg";